import PropTypes from 'prop-types';
import styles from './FJImageEnhancerInput.module.less';
import UploadIcon from '../../../assets/svg/upload.svg?react';
import AddFileIcon from '../../../assets/svg/add-file.svg?react';
import FJLocalStore from '../../../store/FJLocalStore';
import { useRef } from 'react';
import { UPLOAD_FILE_TYPE_NO_GIF } from '../../../config/dataConfig/FJGenerateData';
import classNames from 'classnames';

const FJImageEnhancerInput = props => {
    const { isDraggingFile, uploadImages, setIsDraggingFile, isDisabled = false, openMediaLibrary } = props;
    const inputRef = useRef(null);
    const _onUploadImg = e => {
        const files = Array.from(e.target.files);
        uploadImages(files);
        e.target.value = null;
    };
    const _onUpload = () => {
        if (isDisabled) return;
        if (window.isEditPage && openMediaLibrary) openMediaLibrary();
        else if (inputRef.current) {
            inputRef.current.click();
        }
    };
    const _onDragOver = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(true);
    };

    const _onDragLeave = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
    };

    const _onDragDrop = e => {
        e.stopPropagation();
        e.preventDefault();
        setIsDraggingFile(false);
        let files = Array.from(e.dataTransfer.files);
        if (files && files.length > 0) {
            uploadImages(files);
        }
    };
    return (
        <div
            className={classNames(styles.box, isDisabled && styles.disabled)}
            onDragOver={_onDragOver}
            onDrop={_onDragDrop}
            onDragLeave={_onDragLeave}
        >
            <div className={classNames(styles.blank, isDraggingFile && styles.dragging)} onClick={_onUpload}>
                {isDraggingFile && !isDisabled ? <AddFileIcon /> : <UploadIcon />}
                <span className={styles.blank_text}>
                    {isDraggingFile && !isDisabled ? FJLocalStore._('drag-and-drop') : FJLocalStore._('upload-image')}
                </span>
            </div>
            <div className={styles.dragging_mask}></div>
            <input
                multiple
                type='file'
                ref={inputRef}
                className={styles.file_input}
                accept={UPLOAD_FILE_TYPE_NO_GIF}
                onChange={_onUploadImg}
            />
        </div>
    );
};
FJImageEnhancerInput.propTypes = {
    openMediaLibrary: PropTypes.func,
    uploadImages: PropTypes.func,
    isDraggingFile: PropTypes.bool,
    setIsDraggingFile: PropTypes.func,
    isDisabled: PropTypes.bool,
};
export default FJImageEnhancerInput;
